var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPostImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9255 0H3.07279C1.37463 0 0 1.40571 0 3.14229V20.856C0 22.5943 1.37463 24 3.07279 24H11.3205L11.567 22.5943C11.6793 21.9549 11.9693 21.3823 12.4169 20.9143L19 14.1943V3.14229C18.9983 1.40571 17.6237 0 15.9255 0ZM4.47088 4.572H8.94177C9.557 4.572 10.0599 5.08629 10.0599 5.71543C10.0599 6.34457 9.55532 6.85714 8.94009 6.85714H4.46921C3.85566 6.85714 3.35274 6.34286 3.35274 5.71371C3.35274 5.08457 3.85566 4.572 4.47088 4.572ZM10.0582 15.9994H4.47088C3.85566 15.9994 3.35274 15.4851 3.35274 14.856C3.35274 14.2269 3.85566 13.7143 4.47088 13.7143H10.0582C10.6735 13.7143 11.1764 14.2286 11.1764 14.8577C11.1764 15.4869 10.6735 15.9994 10.0582 15.9994ZM14.5291 11.4291H4.47088C3.85566 11.4291 3.35274 10.9149 3.35274 10.2857C3.35274 9.65657 3.85566 9.14229 4.47088 9.14229H14.5291C15.1443 9.14229 15.6473 9.65657 15.6473 10.2857C15.6456 10.9149 15.1427 11.4291 14.5291 11.4291Z",
    fill: "#5B93FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8598 27C13.633 27 13.4148 26.9114 13.2516 26.7513C13.054 26.5553 12.9647 26.2742 13.0128 26.0016L13.621 22.5873C13.6519 22.4152 13.7344 22.2568 13.8598 22.1324L22.3642 13.6989C23.4088 12.6613 24.4345 12.9407 24.9963 13.4979L26.4137 14.9034C27.1954 15.6786 27.1954 16.9394 26.4137 17.7146L17.9093 26.1481C17.7856 26.2725 17.6258 26.3543 17.4506 26.3849L14.0093 26.9881C13.9594 26.9949 13.9096 27 13.8598 27Z",
    fill: "#5B93FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPostImg);
export default __webpack_public_path__ + "static/media/job-post-img.28cdc23f1d75518fe2173b8acaa82636.svg";
export { ForwardRef as ReactComponent };